import styled from '@emotion/styled';
import { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';

// components
import DefaultLayout from '@components/_templates/DefaultLayout';
import SellerReRequestContent from '@components/_templates/seller/SellerReRequestContent';
import withAuth from '@components/hocs/withAuth';

// constants
import { MOBILE_MODE, TABLET_MODE } from '@constants/size';
import { useTranslation } from 'next-i18next';

const ReRequestWrapper = styled.div`
  width: 100%;
  padding: 110px 40px;
  margin: 0 auto;

  @media ${TABLET_MODE} {
    max-width: 768px;
  }

  @media ${MOBILE_MODE} {
    max-width: 320px;
    padding: 104px 0;
  }
`;

const ReRequest: NextPage = () => {
  const { t } = useTranslation('seller');
  return (
    <>
      <Head>
        <title>{t('reRequest.meta-title')}</title>
        <meta name="title" content={t('reRequest.meta-title')} />
      </Head>
      <DefaultLayout backgroundGray>
        <ReRequestWrapper>
          {/* Seller ReRequest Content */}
          <SellerReRequestContent />
          {/* Seller ReRequest Content end */}
        </ReRequestWrapper>
      </DefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['seller', 'common', 'component'])),
  },
});

export default withAuth(ReRequest);
